import { toast } from "react-toastify";

import { SyncOfferMetafieldsResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const syncOfferMetafields = async () => {
  const resp = await api.get<SyncOfferMetafieldsResponseBodyType>(
    `v2/offer-metafields/sync`
  );
  return resp.data;
};
export const useSyncOfferMetafields = () => {
  return useMutation<SyncOfferMetafieldsResponseBodyType, Error>({
    mutationKey: ["syncOfferMetafields"],
    mutationFn: async () => syncOfferMetafields(),
    onSuccess: (data) => {
      if (data.status === "ok") toast.success("function synced!");
      else toast.error("error syncing function");
    },
  });
};
